module.exports = __webpack_public_path__ + "static/img/icon_cloud_item3.5869853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_item3.jpg
// module id = 4TDJ
// module chunks = 21